import Urls from "../atoms/urls";
import { ServiceRequest } from "../atoms/Utils/Request";

export const LocationService = {
  getLocalities: (tenantId) => {
    return ServiceRequest({
      serviceName: "getLocalities",
      url: Urls.location.localities,
      params: { tenantId: tenantId },
      useCache: true,
    });
  },
  getRevenueLocalities: async (tenantId) => {
    const response = await ServiceRequest({
      serviceName: "getRevenueLocalities",
      url: Urls.location.revenue_localities,
      params: { tenantId: tenantId },
      useCache: true,
    });
    return response;
  },
  getBusinessServices: async (location1, location2, serviceType, department) => {
    const params = {
      location1,
      ...(location2 ? { location2 } : null), // Include location2 only if it is provided
      serviceType,
      department,
    };

    const response = await ServiceRequest({
      serviceName: "getBusinessServices",
      url: Urls.location.business_services,
      params: params,
      useCache: true,
    });

    return response;
  },
};
